import React, {Component} from "react";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import {RouteComponentProps} from "react-router-dom";
import Layout from "../../containers/Layout";
import Schedule from "../../containers/Schedule";


type RouteParamsType = { id: string }


class SchedulePage extends Component<RouteComponentProps<RouteParamsType>> {
    render() {
        const {match} = this.props;
        const id = +match.params.id;

        return (
            <Layout>
                <Title>Расписание</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Расписание', url: `/schedules`},
                    {name: 'Расписание - детальная страница', url: `/schedules/${id}`}
                ]}/>
                <Schedule id={id}/>
            </Layout>
        );
    }
}


export default SchedulePage;

